import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { appendQueryString, getQueryObject, ROUTES } from 'Utils';
import * as analytics from 'Utils/analytics';
import submitCredentialsForActivationCode from 'Services/activation';
import { withLogin } from 'Components/hocs';
import InputField from 'Components/InputField';
import ProgressBar from 'Components/ProgressBar';
const { EVENTS } = analytics;

const ActivationCode = (props) => {
  const { strings, transitionTo, uim } = props;
  const { activationCode } = getQueryObject(props) ?? '';
  const [submitting, setSubmitting] = useState(false);
  const [validForm, setValidForm] = useState(false);
  const [value, setValue] = useState(activationCode);
  const [failureMessage, setFailureMessage] = useState('');

  // TODO: How many characters is a code?
  const isValidCode = (code) => ({ valid: code?.length > 5 });

  const isValidForm = () =>
    setValidForm(isValidCode(value).valid && !submitting);

  const handleChange = ({ target }) => setValue(target.value);

  const handleSubmit = async (event) => {
    event.preventDefault();
    analytics.event({ action: EVENTS.submit, label: 'activation' });
    setSubmitting(true);
    try {
      const code = value.toUpperCase();
      await submitCredentialsForActivationCode(uim, code);
      // Redirect to activation success page
      const successUrl = appendQueryString(
        ROUTES.ACTIVATION_SUCCESS.url,
        `activationCode=${code}`
      );
      transitionTo(successUrl);
    } catch {
      setSubmitting(false);
      setFailureMessage(strings.activationCodeInvalid);
    }
  };

  useEffect(isValidForm, [value]);

  return (
    <div className="login">
      {submitting && <ProgressBar />}
      <h1 className="page-heading">{strings.activateDevice}</h1>
      <form onSubmit={handleSubmit} className="email-form">
        <InputField
          autoFocus
          disabled={submitting}
          failureMessage={failureMessage}
          id="code"
          isValid={isValidCode}
          label={strings.activationCode}
          name="code"
          onChange={handleChange}
          type="text"
          value={value}
        />
        <button type="submit" disabled={!validForm || submitting}>
          {strings.activate}
        </button>
      </form>
    </div>
  );
};

ActivationCode.propTypes = {
  strings: PropTypes.object.isRequired,
  transitionTo: PropTypes.func.isRequired,
  uim: PropTypes.object.isRequired,
};

export default withLogin(ActivationCode);
